// extracted by mini-css-extract-plugin
module.exports = {"banner":"_93444fe79c--banner--YR8Vo","left-border":"_93444fe79c--left-border--MVpKU","right-border":"_93444fe79c--right-border--ny4Xi"};